import { render, staticRenderFns } from "./fztest.vue?vue&type=template&id=f32b511a&scoped=true&"
import script from "./fztest.vue?vue&type=script&lang=js&"
export * from "./fztest.vue?vue&type=script&lang=js&"
import style0 from "./fztest.vue?vue&type=style&index=0&id=f32b511a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32b511a",
  null
  
)

export default component.exports